import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ISimpleListItem } from '../../../../core/interfaces/ISimpleListItem';
import { IDateRangeSalesHistoryItem } from '../../../articles/core/interfaces/IDateRangeSalesHistoryItem';
import { environment } from '../../../../../environments/environment';
import { ArticlesService } from '../../../articles/core/ArticlesService';
import { NotificationService } from '../../../../core/services';
import * as moment from 'moment/moment';
import { finalize } from 'rxjs/operators';
import { StoresService } from '../../../stores/core/services/StoresService';

@Component({
    selector: 'app-today-sales-by-location-chart',
    templateUrl: './today-sales-by-location-chart.component.html',
    styleUrl: './today-sales-by-location-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TodaySalesByLocationChartComponent {

  public results: IDateRangeSalesHistoryItem[] = [];
  public stores: ISimpleListItem[] = [];
  public totalAmount: number;
  public totalCount: number;
  public total = 0;
  public pageIndex = 1;
  public pageSize = 10;
  public readonly isLoading = signal(true);
  public readonly dateFormat = environment.defaultDateFormat;

  public constructor(
    private readonly _articlesService: ArticlesService,
    private readonly _notifyService: NotificationService,
    private readonly _storeService: StoresService,
  ) {}

  public ngOnInit(): void {
    this._storeService.getSimple()
      .subscribe(res => {
        this.stores = res;
        this.loadData();
      });
  }

  public onPageChange(page: number): void {
    this.pageIndex = page;
    this.loadData();
  }

  public onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.pageIndex = 1;
    this.loadData();
  }

  private loadData(): void {
    this.isLoading.set(true);

    this._articlesService.getAllArticlesDateRangeSalesHistory(
      this.pageIndex,
      this.pageSize,
      moment().startOf('day'),
      moment().endOf('day')
    )
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: res => {
          this.total = res.info.totalResults;
          this.results = res.results;
          this.totalAmount = this.results
            .reduce((acc, item) => acc + item.totalAmount, 0);
          this.totalCount = this.results
            .reduce((acc, item) => acc + item.totalCount, 0);
        },
        error: () => this._notifyService.pushError('Fehler', `Fehler beim Laden der Verkaufshistorie.`)
      });
  }
}
